import React, { useContext, useMemo, useState } from 'react';
import styled from 'styled-components';
import { Text, Icon, InputNumber, theme, Tooltip } from 'components';
import { formatCurrency } from 'utils';
import AppointmentDeskContext from '../../AppointmentDeskContext';
import { pricingTierCalculator } from '../../util';

const PriceEstimator: React.FC = () => {
  const { enhancedPrices, enabledListingsCount } = useContext(
    AppointmentDeskContext,
  );
  const [listingsCount, setListingsCount] = useState<number>(100);

  const pricePerListing = useMemo(
    () =>
      enhancedPrices.length &&
      pricingTierCalculator(enhancedPrices, listingsCount),
    [enhancedPrices, listingsCount],
  );

  return (
    <StyledPriceEstimatorContainer>
      <StyledHeaderContainer>
        <StyledHeaderText>Price Estimate</StyledHeaderText>
        <Tooltip
          title={
            'This is an estimate. Price subject to change based on number of listings selected.'
          }
        >
          <span>
            {' '}
            <Icon type="antdInfoCircleFilled" color="grey" />
          </span>
        </Tooltip>
      </StyledHeaderContainer>
      <StyledPriceInfoContainer>
        <StyledPriceText>{formatCurrency(pricePerListing)}</StyledPriceText>{' '}
        <StyledPriceDetailsText type="secondary">
          per active listing / month
        </StyledPriceDetailsText>
      </StyledPriceInfoContainer>
      <StyledPriceInputContainer>
        <StyledPriceInputText type="secondary">
          Active Listings Price Estimator
        </StyledPriceInputText>
        <StyledPriceInput
          min={0}
          value={listingsCount}
          onChange={e => setListingsCount(e as number)}
        />
        <StyledSetCurrentListings
          onClick={() => setListingsCount(enabledListingsCount)}
        >
          Select my current total # of listings
        </StyledSetCurrentListings>
      </StyledPriceInputContainer>
    </StyledPriceEstimatorContainer>
  );
};

export default PriceEstimator;

const StyledPriceEstimatorContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 16px;
  width: 100%;
  height: 200px;
  border: 1px solid ${theme.gray4};
  border-radisu: 4px;
`;

const StyledHeaderContainer = styled.div`
  display: flex;
  justify-content: space-between;
  padding-bottom: 16px;
`;

const StyledHeaderText = styled(Text)`
  font-weight: 600;
  font-size: 16px;
`;

const StyledPriceInfoContainer = styled.div`
  padding-bottom: 16px;
  font-size: 14px;
  font-weight: 400;
`;

const StyledPriceText = styled(Text)`
  font-size: 20px;
  font-weight: 600;
`;

const StyledPriceDetailsText = styled(Text)`
  padding-left: 8px;
`;

const StyledPriceInputContainer = styled.div``;

const StyledPriceInputText = styled(Text)``;

const StyledPriceInput = styled(InputNumber)`
  border-radius: 2px;
`;

const StyledSetCurrentListings = styled.span`
  cursor: pointer;
  padding-top: 4px;
  color: ${theme.blue6};
`;
